"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Namespace = void 0;
const HashedObject_1 = require("./HashedObject");
class Namespace {
    constructor(id) {
        this.id = id;
        this.definitions = new Map();
    }
    define(key, mut) {
        mut.setId(HashedObject_1.HashedObject.generateIdForPath(this.id, key));
        this.definitions.set(key, mut);
    }
    get(key) {
        return this.definitions.get(key);
    }
    getAll() {
        return this.definitions.values();
    }
}
exports.Namespace = Namespace;
//# sourceMappingURL=Namespace.js.map